import ReactPlayer from "react-player";
import { useCallback, useEffect, useRef, useState } from "react";
import holinesstvimg from "../otherImg/hbrlitenewicon.png";
import {
  HbrDropUpIcon,
  HbrDropdownIcon,
  HbrPlayButtonRound,
} from "../newComponents/Mycustomsvgicons";
import { format } from "date-fns";
import { get, ref } from "firebase/database";
import { realTimeDB } from "../firebase";
import { CircularProgress } from "@mui/material";
import TodaySchedule from "./TodaySchedule";
import tvaxiosapi from "../api/tvaxiosapi";
import { ConstVariables } from "./ConstantVariables";

const TvPage = () => {
  const [currentVideo, setCurrentVideo] = useState(null);
  const [preparingVideo, setPreparing] = useState(true);
  const [isplaying, setIsPlaying] = useState(false);
  const [buffering, setBuffering] = useState(false);
  const [videoAds, setVideoAds] = useState([]);
  const [playVideoAds, setPlayVideoAds] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isVideoEnded, setIsVideoEnded] = useState(false);
  const [currentVideoAdIndex, setCurrentAdIndex] = useState(0);
  const [tvFooterDetails, setTvFooterDetails] = useState("");
  const [scheduledVideos, setScheduledVideos] = useState([]);
  const [isFetchingSchedules, setIsFetchingSchedules] = useState(false);
  const [erroralert, seterroralert] = useState(false);
  const [showSchedules, setShowSchedules] = useState(false);
  const [time, setTime] = useState(new Date());
  const videoRef = useRef(null);
  const scrollRef = useRef();

  const fetchVideo = useCallback(async () => {
    try {
      const res = await tvaxiosapi.post(
        "tvshows/currentshow",
        JSON.stringify({ api_key: ConstVariables.WEB_BOOKS_API_KEY }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: false,
        }
      );
      if (res.status === 200) {
        const result = res?.data;
        setCurrentVideo(result);
        setPlayVideoAds(false);
      } else {
        const result = res?.data;
        setVideoAds(result);
        setPlayVideoAds(true);
      }
      setPreparing(false);
      setIsVideoEnded(false);
      setIsFetching(false);
    } catch (error) {
      setPreparing(false);
      setIsVideoEnded(false);
      setIsFetching(false);
      if (!error?.response) {
        console.error("something went wrong", error);
      } else {
        console.error(error?.response.data.message);
      }
      console.error(error);
    }
  }, []);

  const fetchAllVideos = useCallback(async () => {
    setIsFetchingSchedules(true);
    try {
      const res = await tvaxiosapi.post(
        "tvshows/allvideos",
        JSON.stringify({
          api_key: ConstVariables.WEB_BOOKS_API_KEY,
          requestType: "todayvideos",
        }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: false,
        }
      );
      const data = res?.data;
      setScheduledVideos(data);
    } catch (error) {
      seterroralert(true);
      setIsFetchingSchedules(false);
      console.error("error fetching all videos", error);
    }
  }, []);

  // const fetchVideo = useCallback(async () => {
  //   try {

  //     const res = await fetch(`${process.env.REACT_APP_HBRAPI}/tvshows`);
  //     if (res.status === 204) {
  //       try {
  //         setIsFetching(true);

  //         const res = await fetch(
  //           `${process.env.REACT_APP_HBRAPI}/tvshows/videoads`
  //         );
  //         const result = await res.json();
  //         setVideoAds(result);
  //         setPlayVideoAds(true);
  //         setPreparing(false);
  //       } catch {
  //         setIsFetching(false);
  //       } finally {
  //         setIsFetching(false);
  //         setIsVideoEnded(false);
  //       }
  //     } else {
  //       const result = await res.json();
  //       setCurrentVideo(result);
  //       setPreparing(false);
  //       setPlayVideoAds(false);
  //       setIsVideoEnded(false);
  //     }
  //   } catch {
  //     setPreparing(false);
  //     setIsVideoEnded(false);
  //   }
  // }, []);

  useEffect(() => {
    Promise.all([fetchVideo(), fetchAllVideos()]);
  }, [fetchVideo, fetchAllVideos]);

  const handleVideoAdEnded = () => {
    setIsVideoEnded(true);
    try {
      if (currentVideoAdIndex >= videoAds.length - 1) {
        setCurrentAdIndex(0);
        fetchVideo();
      } else {
        setCurrentAdIndex((prev) => prev + 1);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsVideoEnded(false);
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    // Clear interval on unmount
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (scrollRef.current) {
        if (
          scrollRef.current.scrollWidth - scrollRef.current.scrollLeft <=
          scrollRef.current.clientWidth
        ) {
          scrollRef.current.scrollLeft = 0;
        } else {
          scrollRef.current.scrollLeft += 1;
        }
      }
    }, 40);

    return () => clearInterval(intervalId);
  }, []);

  const handleBuffering = () => {
    setBuffering(true);
  };

  const handleBufferEnd = () => {
    setBuffering(false);
  };

  const handleSeekTo = () => {
    setPreparing(false);
    setTimeout(() => {
      videoRef.current.seekTo(
        parseFloat(currentVideo && currentVideo.playbackPosition)
      );
    }, 2000);
  };

  useEffect(() => {
    async function fetchExternalTvdetails() {
      const tvFooterSnapshot = await get(
        ref(realTimeDB, "Banner/hbrTv/footer")
      );
      if (tvFooterSnapshot.exists()) {
        setTvFooterDetails(tvFooterSnapshot.val());
      }
    }
    fetchExternalTvdetails();
  }, []);

  return (
    <div
      className="tvpage"
      style={{
        width: "100%",
        height: "100vh",
        position: "relative",
        backgroundColor: "black",
        overflow: "hidden",
      }}
    >
      <div
        className="flex-column2"
        style={{
          position: "absolute",
          zIndex: "1",
          top: "1em",
          right: "0.5em",
        }}
      >
        <img id="holinesstvimgrotate" src={holinesstvimg} alt="" />
        <h4 style={{ color: "yellow", fontWeight: "bolder" }}>Holiness Tv</h4>
      </div>

      <div
        className="flex-column2"
        style={{
          position: "absolute",
          zIndex: "3",
          top: "1em",
          left: "0.5em",
          cursor: "pointer",
          caretColor: "transparent",
        }}
        onClick={() => setShowSchedules((prev) => !prev)}
      >
        <div className="flex-row2">
          <h4 style={{ color: "yellow", fontWeight: "bolder" }}>Schedules</h4>
          {!showSchedules ? (
            <HbrDropdownIcon width="1.8em" height="1.8em" fillColour="white" />
          ) : (
            <HbrDropUpIcon width="1.8em" height="1.8em" fillColour="white" />
          )}
        </div>
      </div>

      {showSchedules && (
        <div className="tvscheduleontvpage flex-column1">
          <h4 style={{ color: "white" }}>Today shows</h4>

          {isFetchingSchedules && (
            <div
              style={{
                position: "absolute",
                top: "40%",
                left: "45%",
                width: "50px",
                height: "50px",
                border: "5px solid transparent",
                borderTop: "5px solid red",
                borderRadius: "50%",
                animation: "spin2 2s linear infinite",
              }}
            ></div>
          )}

          {erroralert && (
            <p style={{ color: "white" }}>
              something went wrong!! Try again later
            </p>
          )}

          {scheduledVideos &&
            scheduledVideos.map((data) => (
              <TodaySchedule
                key={data._id}
                videoThumbnail={data.videoThumbnail}
                videoTitle={data.videoTitle}
                startTime={data.startTime}
                endTime={data.endTime}
              />
            ))}
        </div>
      )}

      {currentVideo && !isplaying && (
        <div
          onClick={() => setIsPlaying(true)}
          className="startTvtransmission flex-column2"
        >
          <HbrPlayButtonRound width="3em" height="3em" fillColour="white" />
          <pre
            style={{ color: "white", whiteSpace: "pre-wrap" }}
          >{`Auto play is off \n Click to start playing`}</pre>
        </div>
      )}
      {videoAds && !isplaying && (
        <div
          onClick={() => setIsPlaying(true)}
          className="startTvtransmission flex-column2"
        >
          <HbrPlayButtonRound width="3em" height="3em" fillColour="white" />
          <pre
            style={{ color: "white", whiteSpace: "pre-wrap" }}
          >{`Auto play is off \nClick to start playing`}</pre>
        </div>
      )}

      <div style={{ width: "100%", height: "100%" }}>
        <div className="playeroverlay"></div>
        {isVideoEnded && (
          <div className="startTvtransmission flex-column2">
            <div style={{ backgroundColor: "white" }}>
              <CircularProgress />
            </div>
            <pre
              style={{ color: "white", whiteSpace: "pre-wrap" }}
            >{`Preparing next video`}</pre>
          </div>
        )}
        {!playVideoAds && currentVideo && currentVideo.videoUrl && (
          <ReactPlayer
            url={currentVideo.videoUrl}
            ref={videoRef}
            playing={isplaying}
            // onPlay={handleSeekTo}
            onStart={handleSeekTo}
            onBuffer={handleBuffering}
            onBufferEnd={handleBufferEnd}
            // onReady={handleSeekTo}
            onEnded={fetchVideo}
            width={"100%"}
            height={"100%"}
            config={{
              youtube: {
                playerVars: {
                  modestbranding: 1,
                  controls: 0,
                  showinfo: 0,
                },
              },
            }}
          />
        )}
        {playVideoAds && !isFetching && videoAds[currentVideoAdIndex] && (
          <ReactPlayer
            key={currentVideoAdIndex}
            url={videoAds[currentVideoAdIndex].videoUrl}
            ref={videoRef}
            playing={isplaying}
            onBuffer={handleBuffering}
            onBufferEnd={handleBufferEnd}
            onEnded={handleVideoAdEnded}
            width={"100%"}
            height={"100%"}
            config={{
              youtube: {
                playerVars: {
                  modestbranding: 1,
                  controls: 0,
                  showinfo: 0,
                },
              },
            }}
          />
        )}
      </div>

      {currentVideo && currentVideo.videoDesc && (
        <div
          style={{
            display: "flex",
            flex: 1,
            width: "100%",
            height: "5%",
            position: "absolute",
            bottom: "1%",
            left: "0px",
            zIndex: "2",
          }}
        >
          <div
            className="flex-row2"
            style={{
              background: "red",
              padding: "3px",
              borderRadius: "10px",
              width: "100px",
              height: "100%",
            }}
          >
            <p style={{ color: "white", fontWeight: "bold" }}>
              {format(time, "hh:mm a")}
            </p>
          </div>

          <div
            ref={scrollRef}
            className="marqueediv flex-row2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "blue",
              padding: "2px",
              height: "100%",
            }}
          >
            <pre className="marquee-content">
              {` ${tvFooterDetails} >>>>>>>>>>>>> Currently playing: ${
                currentVideo && currentVideo.videoDesc
              }  >>>>>>>>>>>>> ${tvFooterDetails}  >>>>>>>>>>>>>   Currently playing: ${
                currentVideo && currentVideo.videoDesc
              }`}
            </pre>
          </div>
        </div>
      )}

      {buffering && (
        <div
          style={{
            position: "absolute",
            top: "45%",
            left: "47%",
            width: "50px",
            height: "50px",
            borderRadius: "50px",
            border: "5px solid white",
            borderTop: "5px solid #eb268f",
            animation: "spin 2s linear infinite",
          }}
        ></div>
      )}
      {preparingVideo && (
        <div
          style={{
            position: "absolute",
            top: "45%",
            left: "45%",
            width: "50px",
            height: "50px",
            borderRadius: "50px",
            border: "5px solid white",
            borderTop: "5px solid #eb268f",
            animation: "spin 2s linear infinite",
          }}
        ></div>
      )}
    </div>
  );
};
export default TvPage;
